import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { Button, useTheme } from '@mui/material';

import isEmpty from 'lodash/isEmpty';

interface IBackButtonProperties {
  label?: string;
  path: number | string;
  handleBack?: () => void;
  navigateOptions?: unknown;
}

export const BackButton = ({
  path,
  label,
  navigateOptions = {},
  handleBack = () => {},
}: IBackButtonProperties) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    if (typeof path === 'number') {
      navigate(path);
    } else if (isEmpty(navigateOptions)) {
      navigate(path);
    } else {
      navigate(path, { state: navigateOptions });
    }

    handleBack();
  }, [navigate, navigateOptions, path, handleBack]);

  return (
    <Button
      sx={{
        transition: '.2s',
        minWidth: '6.875rem',
        paddingInline: '1rem',
        lineHeight: 'initial',
        color: theme.palette.text.primary,
        '&:after': {
          boxShadow: 'none',
        },
        '&:hover': {
          transition: '.2s',
          backgroundColor: 'transparent',
          color: theme.palette.text.primary,
        },
      }}
      onClick={handleClick}
      startIcon={<FaArrowLeft />}
    >
      {label ?? t('common.button.go.back')}
    </Button>
  );
};
